/* unplugin-vue-components disabled */import { render } from "./file-skeleton.vue?vue&type=template&id=7ec50b44&scoped=true"
const script = {}

import "./file-skeleton.vue?vue&type=style&index=0&id=7ec50b44&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec50b44"],['__file',"src/components/ai-chat/ai-file/file-skeleton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ec50b44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ec50b44', __exports__)) {
    api.reload('7ec50b44', __exports__)
  }
  
  module.hot.accept("./file-skeleton.vue?vue&type=template&id=7ec50b44&scoped=true", () => {
    api.rerender('7ec50b44', render)
  })

}


export default __exports__